import React from 'react';
import PropTypes from 'prop-types';
import { getAnswerClass } from './utils';
export default function MatrixHorizontal({
  question,
  rows,
  columns,
  onHandleMatrixQuestionTap,
  onHandleMatrixAnswerTap,
}) {
  return (
    <div className="matrix-wrapper">
      <table cellPadding={0} cellSpacing={0} border={0}>
        <tbody>
          {rows.map((row, index) => {
            const rowColumns = columns[index];
            return (
              <tr
                className="matrix-horizontal answerMatrix"
                data-answer-id={row.id}
                key={row.id}
              >
                {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-element-interactions,jsx-a11y/click-events-have-key-events */}
                <td
                  className="matrix-horizontal__question"
                  onClick={onHandleMatrixQuestionTap}
                >
                  <span
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: row.body || '&nbsp;' }}
                  />
                </td>
                <td className="matrix-horizontal__row" data-answer-id={row.id}>
                  <div className="matrix-horizontal__inner-table">
                    <table cellPadding={0} cellSpacing={0} border={0}>
                      <tbody>
                        <tr>
                          <td style={{ verticalAlign: 'top' }}>
                            <div
                              className="matrix-horizontal__answers"
                              data-answer-id={row.id}
                            >
                              {rowColumns.map((column) => (
                                // eslint-disable-next-line jsx-a11y/no-static-element-interactions,jsx-a11y/click-events-have-key-events
                                <div
                                  key={column.id}
                                  data-answer-id={row.id}
                                  data-scorepoint-id={column.id}
                                  className={`matrix__answer matrix-horizontal__answer ${getAnswerClass(
                                    { question, column },
                                  )}`}
                                  onClick={onHandleMatrixAnswerTap}
                                >
                                  <span
                                    // eslint-disable-next-line react/no-danger
                                    dangerouslySetInnerHTML={{
                                      __html: column.body || '&nbsp;',
                                    }}
                                  />
                                </div>
                              ))}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className="matrix__labels matrix-horizontal__labels">
                    {rowColumns.map((column) => (
                      <span
                        key={`label-${column.id}`}
                        className="matrix__selected-answer matrix-horizontal__selected-answer"
                        data-scorepoint-id={column.id}
                        data-answer-id={row.id}
                      >
                        <span
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: column.body || '&nbsp;',
                          }}
                        />
                      </span>
                    ))}
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

MatrixHorizontal.propTypes = {
  question: PropTypes.object,
  rows: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  onHandleMatrixQuestionTap: PropTypes.func.isRequired,
  onHandleMatrixAnswerTap: PropTypes.func.isRequired,
};
